import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { connectField } from 'uniforms';

export const BottomBarSelect = connectField(
  ({ value, onChange, options, defaultValue, label }: any) => {
    return (
      <div className="flex-col mt-1">
        <label htmlFor="textAlignSelect">{label}</label>
        <Select
          id={'textAlignSelect'}
          name={'textAlignSelect'}
          onChange={(e) => onChange(e.target.value)}
          // onBlur={handleBlur}
          defaultValue={value ? value : 'None'}
          variant="outlined"
        >
          {options.map((opt: any) => {
            return (
              <MenuItem key={opt.key} value={opt.value}>
                {opt.label}
              </MenuItem>
            );
          })}
        </Select>
      </div>
    );
  }
);
